import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppErrorBoundary } from '@/components/error-boundary'
import { TooltipProvider } from '@/components/ui/tooltip'
import { installGlobalErrorReporting } from '@/lib/monitoring'
import { registerServiceWorker } from '@/lib/pwa'
import { queryClient } from '@/lib/query-client'
import { installSpanishErrorMap } from '@/lib/zod-es'
import { routeTree } from './routeTree.gen'
import './index.css'

installSpanishErrorMap()
installGlobalErrorReporting()

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Los datos los administra TanStack Query; el router no guarda su propia caché.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Falta el elemento #root en index.html')

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>,
)

// Solo en producción: en desarrollo el service worker interferiría con la recarga en caliente.
if (import.meta.env.PROD) registerServiceWorker()
